import registerCustomElement from '@sonicgarden/vue-custom-element-rails'
import BootstrapVue from 'bootstrap-vue'
import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import VTooltipPlugin from 'v-tooltip'

import BusinessToaRecommendations from '../containers/BusinessToaRecommendations.vue'
import OwnerSellerFileContainer from '../containers/OwnerSellerFileContainer.vue'
import * as railsRoutes from '../lib/rails-routes'

Vue.use(VueCompositionApi)
Vue.use(VTooltipPlugin)
Vue.use(BootstrapVue)
Vue.prototype.$rails = railsRoutes

registerCustomElement('app-business-toa-recommendations', BusinessToaRecommendations)
registerCustomElement('app-owner-seller-file-container', OwnerSellerFileContainer)
